const i18n = {
    account: "Account Settings",
    activity: "Activity",
    guest: "Guest",
    download: "Download",
    marketplaceAuthorizations: "Marketplace Authorizations",
    myAssets: "My Assets",
    myLists: "My Lists",
    profile: "Profile",
    signIn: "Sign In",
    signOut: "Log Out",
    viewProfile: "View Profile",
};
export { i18n };
//# sourceMappingURL=UserMenu.i18n.js.map